import * as API_ROUTES from '../../routing/api';
import { requests } from '../../helper/agent';
import { userLogout } from './user';
import {
  CCSD_DEFAULT_CHANGES_BULK_CHECK_ERROR,
  CCSD_DEFAULT_CHANGES_BULK_CHECK_REQUEST,
  CCSD_DEFAULT_CHANGES_BULK_CHECK_SUCCESS,
  CCSD_DEFAULT_CHANGES_CHECK_ERROR,
  CCSD_DEFAULT_CHANGES_CHECK_REQUEST,
  CCSD_DEFAULT_CHANGES_CHECK_SUCCESS,
  CCSD_DEFAULT_CHANGES_LIST_CLEAR_FILTERS,
  CCSD_DEFAULT_CHANGES_LIST_ERROR,
  CCSD_DEFAULT_CHANGES_LIST_REQUEST,
  CCSD_DEFAULT_CHANGES_LIST_SET_FILTERS,
  CCSD_DEFAULT_CHANGES_LIST_SET_PAGE,
  CCSD_DEFAULT_CHANGES_LIST_UNLOAD,
  CCSD_DEFAULT_CHANGES_LIST_UPDATED,
} from '../constants';

export const ccsdDefaultChangesListRequest = () => ({ type: CCSD_DEFAULT_CHANGES_LIST_REQUEST });
export const ccsdDefaultChangesListUpdated = (data) => ({ type: CCSD_DEFAULT_CHANGES_LIST_UPDATED, data });
export const ccsdDefaultChangesListError = (error) => ({ type: CCSD_DEFAULT_CHANGES_LIST_ERROR, error });
export const ccsdDefaultChangesListUnload = () => ({ type: CCSD_DEFAULT_CHANGES_LIST_UNLOAD });
export const ccsdDefaultChangesListSetPage = (page) => ({ type: CCSD_DEFAULT_CHANGES_LIST_SET_PAGE, page });
export const ccsdDefaultChangesListSetFilters = (filters, routeKey) => ({ type: CCSD_DEFAULT_CHANGES_LIST_SET_FILTERS, filters, routeKey });
export const ccsdDefaultChangesListClearFilters = (routeKey) => ({ type: CCSD_DEFAULT_CHANGES_LIST_CLEAR_FILTERS, routeKey });

export const ccsdDefaultChangesListFetch = (page = 1, filters = {}) => {
  return (dispatch) => {
    dispatch(ccsdDefaultChangesListRequest());
    filters.page = page;
    return requests
      .get(API_ROUTES.DATED_COSTS, filters)
      .then((response) => dispatch(ccsdDefaultChangesListUpdated(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        }
        dispatch(ccsdDefaultChangesListError(error));
      });
  };
};

export const ccsdDefaultChangesCheck = (id) => {
  return (dispatch) => {
    dispatch({ type: CCSD_DEFAULT_CHANGES_CHECK_REQUEST, id });
    return requests
      .post(API_ROUTES.DATED_COSTS_CHECK.replace(':id', id), {})
      .then((response) => {
        dispatch({ type: CCSD_DEFAULT_CHANGES_CHECK_SUCCESS, data: response });
        return response;
      })
      .catch((error) => {
        dispatch({ type: CCSD_DEFAULT_CHANGES_CHECK_ERROR, error });
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        }
        throw error;
      });
  };
};

export const ccsdDefaultChangesUncheck = (id) => {
  return (dispatch) => {
    dispatch({ type: CCSD_DEFAULT_CHANGES_CHECK_REQUEST, id });
    return requests
      .post(API_ROUTES.DATED_COSTS_UNCHECK.replace(':id', id), {})
      .then((response) => {
        dispatch({ type: CCSD_DEFAULT_CHANGES_CHECK_SUCCESS, data: response });
        return response;
      })
      .catch((error) => {
        dispatch({ type: CCSD_DEFAULT_CHANGES_CHECK_ERROR, error });
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        }
        throw error;
      });
  };
};

export const ccsdDefaultChangesBulkCheck = (ids, page, filters) => {
  return (dispatch) => {
    dispatch({ type: CCSD_DEFAULT_CHANGES_BULK_CHECK_REQUEST });
    return requests
      .post(API_ROUTES.DATED_COSTS_BULK_CHECK, { ids })
      .then((response) => {
        dispatch({ type: CCSD_DEFAULT_CHANGES_BULK_CHECK_SUCCESS });
        dispatch(ccsdDefaultChangesListFetch(page, { ...filters }));
        return response;
      })
      .catch((error) => {
        dispatch({ type: CCSD_DEFAULT_CHANGES_BULK_CHECK_ERROR, error });
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        }
        throw error;
      });
  };
};